module.exports = __webpack_public_path__ + "media/images/profile-e5c169f51676430cf53a4267decc6a1c.png";